export const findFirstValidKey = function (
    ruleset: Record<string, boolean>,
): string {
    return Object.keys(ruleset).find((key) => ruleset[key]) ?? '';
};
